import React, { useRef, useState, useEffect, useCallback } from "react";
import { fabric } from "fabric";
import { toast } from "react-toastify";
import Utils from "../../utils";
import {
  getCustomerSignDocumentPages,
  updateCustomerSignOnDocument
} from "../../services/CommonService";
import CustomerSummary from './CustomerSummary';
import ModalComponent from "../../components/ModalComponent";

function SignFillablePopup({
  setLoading,
  handleSignFillableRequest,
  signFillRequest,
  signatureDocumentData,
  formObj,
  setSignDocumentList,
  summaries,
  setSummaries,
}) {
  const clsFormButtonRef = useRef();
  const containerRef = useRef();
  const autoFillEditModeRef = useRef();

  const canvasSignRef = useRef(null);
  const signpadBackgroundTextRef = useRef(null);

  const yourNameRef = useRef(null);
  const offCanvasBodyRef = useRef(null);
  const inputFileImageRef = useRef(null);

  const [showSignModal, setShowSignModal] = useState(false);
  const [signDocId, setSignDocId] = useState(0);
  const [signDocMode, setSignDocMode] = useState(1);

  const [canvas, setCanvas] = useState("");
  const [imageList, setImageList] = useState([]);
  const [recipients, setRecipients] = useState([]);

  const [activeTab, setActiveTab] = useState("type");
  const [signText, setSignText] = useState("");
  const [signFont, setSignFont] = useState("");

  const [fonts, setFonts] = useState([
    "Great Vibes",
    "Playball",
    "Sacramento",
    "Sarina",
    "Dr Sugiyama",
    "Princess Sofia",
  ]);

  const [uploadImageBase64, setUploadImageBase64] = useState("");

  const [requestFieldLeft, setRequestFieldLeft] = useState(0);
  const [titleOfSignInitialPopup, setTitleOfSignInitialPopup] = useState("");

  const [summaryData, setSummaryData] = useState([]);
  const [summaryLoading, setSummaryLoading] = useState(false);
  const [showSummaryModal, setShowSummaryModal] = useState(false);

  const [selectedDocumentIndex, setSelectedDocumentIndex] = useState(null);

  useEffect(() => {
    if (signatureDocumentData && formObj?.sign_documents) {
      const index = formObj.sign_documents.findIndex(
        (doc) => doc.id === signatureDocumentData.id
      );
      if (index !== -1) {
        setSummaries(formObj.sign_documents[index].summaries);
      } else {
        setSummaries(null);
        toast.error("No matching document found for summary.");
      }
    } else {
      setSummaries(null);
    }
  }, [signatureDocumentData, formObj]);

  const handleShowSummaryModal = () => {
    if (summaries) {
      setShowSummaryModal(true);
    } else {
      toast.error("No summary available for this document.");
    }
  };

  const handleCloseSummaryModal = () => {
    setShowSummaryModal(false);

  };

  // const renderSummaryButton = () => {
  //   if (signatureDocumentData && formObj?.sign_documents) {
  //     const activeDoc = formObj.sign_documents.find(
  //       (doc) => doc.id === signatureDocumentData.id
  //     );
  //     if (activeDoc) {
  //       return (
  //         <button
  //           key={activeDoc.id}
  //           className="btn btn-outline-primary me-2"
  //           onClick={handleShowSummaryModal}
  //         >
  //           View Summary
  //         </button>
  //       );
  //     }
  //   }
  //   return null;
  // };
  const debounceTimeout = useRef(null);

  fabric.Object.prototype.transparentCorners = false;
  fabric.Object.prototype.cornerColor = "#0c5460";
  fabric.Object.prototype.cornerStyle = "circle";
  fabric.Object.prototype.cornerSize = 5;

  function clearLocalStorage() {
    localStorage.removeItem("pagesPosition");
    localStorage.removeItem("placeholders");
    localStorage.removeItem("nextObjects");
    localStorage.removeItem("localSign");
    localStorage.removeItem("localInitial");
  }

  function clearForm(e) {
    e.preventDefault();
    setImageList([]);
    handleSignFillableRequest();
    clearLocalStorage();
    resetSignPad();
    canvas.clear();
    console.log("Clear...");
  }

  const [pdfDimensions, setPdfDimensions] = useState({ width: 0, height: 0 });
  useEffect(() => {
    if (signatureDocumentData) {

      let { width, height } = signatureDocumentData?.dimensions;
      setPdfDimensions({ width, height });
    }
  }, [signatureDocumentData]);

  useEffect(() => {
    if (!canvas && pdfDimensions.width && pdfDimensions.height) {
      const initCanvas = new fabric.Canvas('canv', {
        height: pdfDimensions.height,
        width: pdfDimensions.width,
      });
      setCanvas(initCanvas);
    } else if (canvas) {
      canvas.setDimensions({
        width: pdfDimensions.width,
        height: pdfDimensions.height,
      });
      canvas.renderAll();
    }
  }, [pdfDimensions, canvas]);

  useEffect(() => {
    const { width, height } = pdfDimensions;
    const dynamicHeight = imageList.length * (height + 25);

    const handleScroll = () => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }

      debounceTimeout.current = setTimeout(() => {
        const scrollableDiv = containerRef.current;
        const scrollTop = scrollableDiv.scrollTop;
        const windowHeight = scrollableDiv.clientHeight;
        const scrollHeight = scrollableDiv.scrollHeight;

        const threshold = 100;

        if (windowHeight + scrollTop >= scrollHeight - threshold) {
          console.log('User is near the bottom, loading more content');

          const newCanvasHeight = Math.min(dynamicHeight, scrollHeight + height);

          canvas.setDimensions({ width: width, height: newCanvasHeight });
          canvas.renderAll();
        }
      }, 200);
    };

    const scrollableDiv = containerRef.current;
    scrollableDiv.addEventListener("scroll", handleScroll);

    return () => {
      scrollableDiv.removeEventListener("scroll", handleScroll);
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
    };
  }, [canvas, imageList, pdfDimensions, containerRef]);

  const renderImageOnCanvas = useCallback(async () => {
    if (signFillRequest === true && imageList.length > 0) {
      canvas.clear().renderAll();

      var pagePositionArr = [];

      var pdfWidth = pdfDimensions.width;
      var pdfHeight = pdfDimensions.height;
      canvas.setDimensions({ width: pdfWidth, height: pdfHeight });

      var imgHeight = pdfHeight;

      let countImg = 1;
      for (var i = 0; i < imageList.length; i++) {
        var topMultiplier = countImg++ * 20;
        var top = ((i * imgHeight) + topMultiplier);

        var imageUrl = imageList[i].file_path;
        fabric.Image.fromURL(
          imageUrl,
          function (img) {

            const scaleX = pdfWidth / img.width;
            const scaleY = pdfHeight / img.height;
            const scale = Math.min(scaleX, scaleY);

            img.scale(scale);
            const imgWidth = img.width * scale;
            const left = (pdfWidth - imgWidth) / 2;

            img.set({
              left: left,
              hasControls: false,
              selectable: false,
              hoverCursor: "default",
            });

            canvas.add(img).renderAll();
          },
          {
            id: "page_" + (i + 1),
            num: 0,
            left: 0,
            top: top,
            hasControls: false,
            selectable: false,
            hoverCursor: "default",
          }
        );

        let objArr = {
          object_id: "page_" + (i + 1),
          position: { left: 0, top: top, width: pdfWidth, height: pdfHeight },
        };
        pagePositionArr.push(objArr);
      }

      let pagesPosition = localStorage.getItem("pagesPosition");
      if (pagesPosition === null) {
        localStorage.setItem("pagesPosition", JSON.stringify(pagePositionArr));
      }

      setTimeout(function () {
        autoFillEditModeRef.current?.click();
      }, 3000);
    }
  }, [signFillRequest, imageList, canvas, pdfDimensions]);

  useEffect(() => {
    renderImageOnCanvas();
  }, [renderImageOnCanvas, pdfDimensions]);

  const fillImageList = useCallback(async () => {

    if (signatureDocumentData?.id) {
      setSignDocMode(parseInt(signatureDocumentData.mode));

      let obj = {
        signature_document_id: signatureDocumentData?.id,
      };

      let recipient_ids = signatureDocumentData.request_id;
      if (recipient_ids !== 0) {

        let envelop_recipients = formObj.recipient_ids;
        recipient_ids = envelop_recipients.split(",");
      } else {
        recipient_ids = recipient_ids.split(",");
      }
      setRecipients(recipient_ids);
      getCustomerSignDocumentPages(obj)
        .then((response) => {
          setSignDocId(signatureDocumentData?.id);
          setImageList(response.data.data);
        })
        .catch((err) => { });
    }
  }, [signatureDocumentData, formObj]);

  useEffect(
    function () {
      if (signFillRequest === true) {
        fillImageList();
        setUploadImageBase64('');
      }
    },
    [signFillRequest, fillImageList]
  );

  function resetSignPad() {

    // setGetStarted(false);
    // setAgreeTermsOfService(false);
    setSignText('');
    setSignFont('');
    deletePreviewImage();
    containerRef.current.style.pointerEvents = "none";
  }

  function handleAutoFillEditMode() {
    var placeholdersArr = [];
    let recObj = [];
    for (let r = 0; r < recipients.length; r++) {
      let recipient_id = recipients[r];
      recObj.push({
        recipient_id: recipient_id,
        type: "",
        value: "",
        font_family: "",
        font_size: "",
      });
    }

    for (var j = 0; j < imageList.length; j++) {
      var placeholderDetailss = imageList[j].placeholder_details;
      var items = placeholderDetailss.items;

      if (items.length > 0) {
        for (let k = 0; k < items.length; k++) {
          let objPlaceholder = items[k];
          if (signDocMode === 2) {
            if (
              objPlaceholder.customer_signature_document_id !== "" &&
              objPlaceholder.value_of_recipient
            ) {
              let recipient_id =
                objPlaceholder.value_of_recipient?.recipient_id;
              let rePrepareRecipient = [];
              for (let m = 0; m < recObj.length; m++) {
                let recObject = recObj[m];
                if (recipient_id === recObject.recipient_id) {
                  let vOfRecipient = objPlaceholder.value_of_recipient;

                  rePrepareRecipient.push(vOfRecipient);
                } else {
                  rePrepareRecipient.push(recObject);
                }
              }
              objPlaceholder.recipients = rePrepareRecipient;
            } else {
              objPlaceholder.recipients = recObj;
            }
          } else {
            objPlaceholder.recipients = recObj;
          }

          placeholdersArr.push(objPlaceholder);
        }
      }
    }

    localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));

    for (var i = 0; i < imageList.length; i++) {
      var placeholderDetails = imageList[i].placeholder_details;
      if (placeholderDetails !== null) {
        let items = placeholderDetails.items;
        for (let j = 0; j < items.length; j++) {
          let item = items[j];

          let objId = item.object_id;
          let backgroundColor = item.color_code;
          let topPositionObject = item.position.top;
          let leftPositionObject = item.position.left;
          let widthObject = item.position.width;
          let heightObject = item.position.height;
          let requestRecipient = item.recipients;
          let dateFormat = item.date_format;
          let textContent = item.text_content;

          if (objId.indexOf("initial-textbox") > -1 && signDocMode === 2) {
            let label = item?.request_recipient?.label;
            textContent = "Click to Initial (" + getInitial(label) + ")";
          }

          if (objId.indexOf("sign") > -1 && signDocMode === 2) {
            let label = item?.request_recipient?.label;
            textContent = "Click to Sign (" + getInitial(label) + ")";
          }

          let fontSize = item.text_font_size;
          let fontFamily = item.text_font_family;

          fabricTool(
            backgroundColor,
            topPositionObject,
            leftPositionObject,
            widthObject,
            heightObject,
            objId,
            requestRecipient,
            fontSize,
            fontFamily,
            dateFormat,
            textContent
          );
        }
      }
    }

    setTimeout(function () {
      autoFillOtherRecipientData();
      setLoading(false);
    }, 3000);

    getRequestFieldLeft();

  }

  function autoFillOtherRecipientData() {
    var placeholdersUpdatedCheck = localStorage.getItem("placeholders");
    if (placeholdersUpdatedCheck !== null) {
      var placeholdersArr = JSON.parse(placeholdersUpdatedCheck);

      for (let j = 0; j < placeholdersArr.length; j++) {
        let objPlaceholder = placeholdersArr[j];
        let notEmptyRecipientRaw = objPlaceholder.recipients.find(
          (i) => i.value !== ""
        );
        if (notEmptyRecipientRaw) {
          let objId = objPlaceholder.object_id;

          if (notEmptyRecipientRaw.type === "type") {
            typeTextChange(objId, true);
          } else if (
            notEmptyRecipientRaw.type === "draw" ||
            notEmptyRecipientRaw.type === "upload"
          ) {
            typeDrawChange(objId, notEmptyRecipientRaw.value, true);
          }
        }
      }
    }
  }

  function getCurrentRecipientName() {
    const firstName = formObj.recipient_detail.first_name;
    const lastName = formObj.recipient_detail.last_name;

    const capitalize = (name) => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();

    const capitalizedFirstName = capitalize(firstName);
    const capitalizedLastName = capitalize(lastName);

    return `${capitalizedFirstName} ${capitalizedLastName}`;
  }

  function createTextLabel(
    textContent,
    fontSize,
    fontFamily,
    textColor,
    originX,
    originY,
    textLeft,
    textTop
  ) {
    return new fabric.Text(textContent, {
      fontSize: fontSize,
      fontFamily: fontFamily,
      fill: textColor,
      originX: originX,
      originY: originY,
      left: textLeft,
      top: textTop,
    });
  }

  function createRectangle(objId, imageWidth, imageHeight, fillColor) {

    var rectWidth = imageWidth + 30;
    var rectHeight = imageHeight + 26;

    let strokeDashArray = [5, 5];
    if (objId.indexOf("initial-textbox") > -1 || objId.indexOf("sign") > -1) {
      strokeDashArray = [0];
    }

    return new fabric.Rect({
      width: rectWidth,
      height: rectHeight,
      radius: 1,
      objectCaching: false,
      fill: "#FFFFFF",
      stroke: fillColor,
      strokeWidth: 3,
      strokeDashArray: strokeDashArray,
      hasControls: false,
    });
  }

  function createImage(imageURL) {

    return new Promise((resolve, reject) => {
      fabric.Image.fromURL(imageURL, function (img) {
        if (img) {
          resolve(img);
        } else {
          toast.error("Failed to load the image:");
          reject("Failed to load the image: " + imageURL);
        }
      });
    });
  }

  function createGroup(
    rect,
    img,
    fTextLabel,
    objId,
    leftPositionObject,
    topPositionObject,
    isSelectable
  ) {
    return new fabric.Group([rect, img, fTextLabel], {
      id: objId,
      left: leftPositionObject,
      top: topPositionObject,
      lockRotation: true,
      preserveObjectStacking: true,
      lockMovementX: true,
      lockMovementY: true,
      lockScalingX: true,
      lockScalingY: true,
      selectable: isSelectable,
    });
  }

  const getRequestFieldLeft = useCallback(() => {
    let totalCount = 0;
    var placeholdersUpdated = localStorage.getItem("placeholders");
    if (placeholdersUpdated !== null) {
      var placeholdersArr = JSON.parse(placeholdersUpdated);

      for (var i = 0; i < placeholdersArr.length; i++) {
        let item = placeholdersArr[i];
        let recipients = item.recipients;
        let current_recipient_id = formObj.recipient_detail.id;

        let foundRecipient = "";
        if (signDocMode === 1) {
          foundRecipient = Array.isArray(recipients)
            ? recipients.find((obj) => obj.recipient_id === current_recipient_id)
            : null;

        } else {
          let request_recipient_id = item.request_recipient?.value;
          if (request_recipient_id === current_recipient_id) {
            foundRecipient = recipients.find(
              (obj) => obj.recipient_id === current_recipient_id
            );
          }
        }

        if (foundRecipient) {
          if (foundRecipient.value === "") {
            totalCount += 1;
          }
        }
      }
      setRequestFieldLeft(totalCount);
    }

    return totalCount;
  }, [formObj, signDocMode]);

  useEffect(() => {
    getRequestFieldLeft();
  }, [getRequestFieldLeft, requestFieldLeft]);

  function fabricTool(
    backgroundColor,
    topPositionObject,
    leftPositionObject,
    widthObject,
    heightObject,
    objId,
    requestRecipient = "",
    fontSize,
    fontFamily,
    dateFormat,
    textContent = ""
  ) {
    var originX = "left";
    var originY = "top";
    var textLeft = 15;
    var textTop = 0;
    var fillColor = "#" + backgroundColor;
    var textColor = "#000000";

    var imageURL = "";
    var textLeftPosition = 12;

    var isSelectable = false;
    if (signDocMode === 1) {
      textContent = getPlaceholderValue(
        objId,
        fontFamily,
        fontSize,
        dateFormat
      );
      if ((objId.indexOf("initial-textbox") > -1) && (textContent === "")) {
        textContent = "Click to Initial";
        isSelectable = true;
      } else if ((objId.indexOf("sign") > -1) && (textContent === "")) {
        textContent = "Click to Sign";
        isSelectable = true;
      } else if (objId.indexOf("static") > -1) {
        textLeftPosition = 15;
        textContent = textContent === "" ? "Add Content" : textContent;
        fillColor = "#d1ecf1";
      }
    } else {
      if (objId.indexOf("initial-textbox") > -1) {
        isSelectable = true;

      } else if (objId.indexOf("sign") > -1) {
        isSelectable = true;

      } else if (
        objId.indexOf("recipient-textbox") > -1 ||
        objId.indexOf("system-date-textbox") > -1 ||
        objId.indexOf("email-address-textbox") > -1
      ) {
        textContent = getPlaceholderValue(
          objId,
          fontFamily,
          fontSize,
          dateFormat
        );
      } else if (objId.indexOf("static") > -1) {
        textLeftPosition = 15;
        textContent = textContent === "" ? "Add Content" : textContent;
        fillColor = "#d1ecf1";
      }
    }

    var fTextLabel = createTextLabel(
      textContent,
      fontSize,
      fontFamily,
      textColor,
      originX,
      originY,
      textLeft,
      textTop
    );

    createImage(imageURL)
      .then((img) => {

        let fTextLabelWidth = "";
        if (fontFamily === "Arial") {
          fTextLabelWidth = textContent.length * 7.5;
        } else if (fontFamily === "Great Vibes") {
          fTextLabelWidth = textContent.length * 15;
        } else if (fontFamily === "Sarina" || fontFamily === "Princess Sofia") {
          fTextLabelWidth = textContent.length * 14;
        } else if (fontFamily === "Sacramento") {
          fTextLabelWidth = textContent.length * 25;
        } else {
          fTextLabelWidth = textContent.length * 8;
        }

        var rect = createRectangle(
          objId,
          fTextLabelWidth,
          fTextLabel.height,
          fillColor,
        );

        var scaleFactor = Math.min(20 / img.width, 20 / img.height);

        var newHeight = img.height * scaleFactor;

        img.set({
          left: rect.left + 10,
          top: 1 + (rect.height - newHeight) / 2,
          scaleX: scaleFactor,
          scaleY: scaleFactor,
          opacity: 0.7,
        });

        fTextLabel.set({
          top: (rect.height - fTextLabel.height) / 2,
          left: textLeftPosition,
        });

        var group = createGroup(
          rect,
          img,
          fTextLabel,
          objId,
          leftPositionObject,
          topPositionObject,
          isSelectable
        );

        group.setControlsVisibility({ mtr: false });

        group.set({
          requestRecipient:
            objId.indexOf("static") === -1 ? requestRecipient : "",
          backgroundColor: backgroundColor,
        });

        canvas.add(group);

        group.on('mousedown', mouseDblClickListener);

        canvas.renderAll();

        var placeholdersUpdated = localStorage.getItem("placeholders");
        var placeholdersArr = JSON.parse(placeholdersUpdated);
        const foundObject = placeholdersArr.find(
          (obj) => obj.object_id === objId
        );

        if (foundObject) {
          let recipients = foundObject.recipients;
          let current_recipient_id = formObj.recipient_detail.id;

          var objects = canvas.getObjects();
          var foundObjectInCanvas = objects.find((obj) => obj.id === objId);

          if (signDocMode === 2) {
            let request_recipient_id = foundObject.request_recipient.value;
            if (request_recipient_id !== undefined) {
              if (request_recipient_id !== current_recipient_id) {

                foundObjectInCanvas.set("selectable", false);
                canvas.renderAll();

                let foundOtherRecipient = recipients.find(
                  (obj) => obj.recipient_id === request_recipient_id
                );

                if (foundOtherRecipient.type === "type") {
                  var objectWithKeyOther = findObjectByKey(
                    foundObjectInCanvas._objects,
                    "text"
                  );
                  objectWithKeyOther.set("text", foundOtherRecipient.value);
                  objectWithKeyOther.set(
                    "fontFamily",
                    foundOtherRecipient.font_family
                  );
                  objectWithKeyOther.set(
                    "fontSize",
                    foundOtherRecipient.font_size
                  );
                  canvas.renderAll();
                }
              } else {

              }
            }
          }

          let foundRecipient = recipients.find(
            (obj) => obj.recipient_id === current_recipient_id
          );

          if (foundRecipient) {
            if (foundObjectInCanvas && foundRecipient.type === "type") {
              var objectWithKey = findObjectByKey(
                foundObjectInCanvas._objects,
                "text"
              );

              objectWithKey.set("text", foundRecipient.value);
              objectWithKey.set("fontFamily", foundRecipient.font_family);
              objectWithKey.set("fontSize", foundRecipient.font_size);
              canvas.renderAll();
            } else if (
              (foundObjectInCanvas && foundRecipient.type === "draw") ||
              (foundObjectInCanvas && foundRecipient.type === "upload")
            ) {
              typeDrawChange(objId, foundRecipient.value);
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);

        toast.error("Failed to load the image:");
      });
  }

  function findObjectByKey(objects, keyToFind) {
    for (const obj of objects) {
      if (obj.hasOwnProperty(keyToFind)) {
        return obj;
      }
    }
    return null;
  }

  function getInitial(name) {
    if (!name) return "";
    const parts = name.split(" ").filter((part) => part.trim());
    if (parts.length === 1) {
      return parts[0].slice(0, 2);
    } else {
      return `${parts[0].charAt(0)}${parts[parts.length - 1].charAt(0)}`;
    }
  }

  function saveForm(e) {
    let placeholdersUpdated = localStorage.getItem("placeholders");
    let placeholders = JSON.parse(placeholdersUpdated);

    if (placeholders === null) {
      toast.error("Oops! Something went wrong.");
      return false;
    }

    let pagesPosition = localStorage.getItem("pagesPosition");
    pagesPosition = JSON.parse(pagesPosition);
    if (pagesPosition === null) {
      toast.error("The positions of the pages are not being updated.");
      return false;
    }

    let current_recipient_id = formObj.recipient_detail.id;
    if (placeholders !== null) {
      if (signDocMode === 2) {
        placeholders = placeholders.filter(
          (obj) => obj.request_recipient.value === current_recipient_id
        );
      }

      for (var i = 0; i < placeholders.length; i++) {
        let recipients = placeholders[i].recipients;
        const foundRecipient = recipients.find(
          (obj) => obj.recipient_id === current_recipient_id
        );
        if (foundRecipient.value === "") {
          toast.error(
            "Please draw a signature or fill in the provided space for text."
          );
          return false;
        }
      }
    }

    let obj = {
      envelope_data: formObj,
      signature_document_id: signDocId,
      mode: signDocMode,
      pages_position: pagesPosition,
      recipient_id: current_recipient_id,
      items: placeholders,
    };

    setLoading(true);
    updateCustomerSignOnDocument(obj)
      .then(async (response) => {
        toast.success(response.data.message || "Document signed successfully!");

        let index = formObj.sign_documents.findIndex(
          (x) => parseInt(x.id) === parseInt(signDocId)
        );

        if (index > -1) {
          formObj.sign_documents[index]["status_id"] = response.data.status_id;
          formObj.sign_documents[index]["status_name"] = response.data.status_name;
          formObj.sign_documents[index]["is_edit"] = false;
        }

        setSignDocumentList(formObj.sign_documents);

        localStorage.setItem("signingCompleted", "true");


        if (window.refreshEnvelopeDataFromParent) {
          await window.refreshEnvelopeDataFromParent();
        }

        clsFormButtonRef.current?.click();
        clearForm(e);
      })
      .catch((err) => {
        toast.error(Utils.getErrorMessage(err));
      })
      .finally(() => {
        setLoading(false);
      });

  }


  const handleTabClick = (tab) => {
    setActiveTab(tab);
  };

  useEffect(() => {

    const signCanvas = new fabric.Canvas(canvasSignRef.current, {
      isDrawingMode: true,
    });

    signCanvas.freeDrawingBrush.width = 3;
    signCanvas.freeDrawingBrush.strokeWidth = 3;
    signCanvas.freeDrawingBrush.smooth = true;

    signCanvas.selection = false;

    const center = signCanvas.getCenter();
    const backgroundText = new fabric.IText("Your Sign Here", {
      fontSize: 24,
      fill: "gray",
      selectable: false,
      left: center.left,
      top: center.top,
      originX: "center",
      originY: "center",
      fontFamily: "Arial",
      fontWeight: "bold",
      opacity: 0.2,
    });

    signCanvas.add(backgroundText);
    signCanvas.sendToBack(backgroundText);

    canvasSignRef.current = signCanvas;
    signpadBackgroundTextRef.current = backgroundText;

    return () => {

      signCanvas.dispose();
    };
  }, []);

  const convertToBase64 = () => {
    if (canvasSignRef.current && signpadBackgroundTextRef.current) {
      const signCanvas = canvasSignRef.current;
      const backgroundText = signpadBackgroundTextRef.current;

      signCanvas.remove(backgroundText);

      const dataURL = signCanvas.toDataURL({
        format: "png",
        quality: 1,
      });

      signCanvas.add(backgroundText);
      signCanvas.sendToBack(backgroundText);

      return dataURL;
    }
  };

  const clearSignValue = () => {
    if (activeTab === "type") {
      setSignText("John Doe");
      setSignFont("");
    } else if (activeTab === "draw") {
      clearSignPad();
    } else {
      setUploadImageBase64("");
      inputFileImageRef.current.value = null;
    }
    setShowSignModal(false);
  };

  const clearSignPad = () => {
    if (canvasSignRef.current && signpadBackgroundTextRef.current) {
      const signCanvas = canvasSignRef.current;
      const backgroundText = signpadBackgroundTextRef.current;
      canvasSignRef.current.clear();

      signCanvas.add(backgroundText);
      signCanvas.sendToBack(backgroundText);
    }
  };

  const storeSignValue = (objId, type = "", value = "", font = "") => {
    var placeholdersUpdated = localStorage.getItem("placeholders");
    var placeholdersArr = JSON.parse(placeholdersUpdated);
    const foundObject = placeholdersArr.find((obj) => obj.object_id === objId);

    if (foundObject) {
      const foundObjectIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objId
      );
      let recipients = foundObject.recipients;
      let current_recipient_id = formObj.recipient_detail.id;
      let request_recipient_id = foundObject?.request_recipient?.value;

      let foundRecipient = "";

      if (signDocMode === 1) {
        foundRecipient = recipients.find(
          (obj) => obj.recipient_id === current_recipient_id
        );
      } else {
        foundRecipient = recipients.find(
          (obj) => obj.recipient_id === request_recipient_id
        );
      }

      if (foundRecipient) {
        let foundRecipientIndex = "";

        if (signDocMode === 1) {
          foundRecipientIndex = recipients.findIndex(
            (obj) => obj.recipient_id === current_recipient_id
          );
        } else {
          foundRecipientIndex = recipients.findIndex(
            (obj) => obj.recipient_id === request_recipient_id
          );
        }

        if (
          objId.indexOf("sign") > -1 ||
          objId.indexOf("initial-textbox") > -1
        ) {
          recipients[foundRecipientIndex].type = type;
          recipients[foundRecipientIndex].value = value;
          recipients[foundRecipientIndex].font_family = font;
          recipients[foundRecipientIndex].font_size =
            parseInt(foundObject.text_font_size) + parseInt(5);
        }

        placeholdersArr[foundObjectIndex].recipients = recipients;
        localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));
      }
    }
  };

  const typeTextChange = (objId, isFillMode = false) => {
    var objects = canvas.getObjects();
    var foundObjectInCanvas = objects.find((obj) => obj.id === objId);

    if (foundObjectInCanvas) {

      let fontFamilyForSign = "";
      if (signFont === "") {

        if (objId.indexOf("sign") > -1) {
          let localSign = localStorage.getItem("localSign");
          if (localSign !== null) {
            localSign = JSON.parse(localSign);
            fontFamilyForSign = fonts[localSign.font];
          }
        }
        if (objId.indexOf("initial-textbox") > -1) {
          let localInitial = localStorage.getItem("localInitial");
          if (localInitial !== null) {
            localInitial = JSON.parse(localInitial);
            fontFamilyForSign = fonts[localInitial.font];
          }
        }
      } else {
        fontFamilyForSign = fonts[signFont];
      }

      canvas.forEachObject(function (obj) {

        if (obj.id === objId) {
          canvas.remove(obj);
        }
      });
      canvas.renderAll();

      if (isFillMode === false) {
        var signInitialData = {
          type: "text",
          font: signFont,
          value: signText
        };

        if (signFont === "") {

          if (objId.indexOf("sign") > -1) {
            let localSign = localStorage.getItem("localSign");
            if (localSign !== null) {
              localSign = JSON.parse(localSign);
              signInitialData = {
                type: "text",
                font: localSign.font,
                value: localSign.value
              };
            }
          }
          if (objId.indexOf("initial-textbox") > -1) {
            let localInitial = localStorage.getItem("localInitial");
            if (localInitial !== null) {
              localInitial = JSON.parse(localInitial);
              signInitialData = {
                type: "text",
                font: localInitial.font,
                value: localInitial.value
              };
            }
          }
        }

        if (objId.indexOf("sign") > -1) {

          localStorage.setItem("localSign", JSON.stringify(signInitialData));
        }

        if (objId.indexOf("initial-textbox") > -1) {

          localStorage.setItem("localInitial", JSON.stringify(signInitialData));
        }

        if (signFont === "") {
          storeSignValue(objId, "type", signInitialData.value, fontFamilyForSign);
        } else {
          storeSignValue(objId, activeTab, signText, fontFamilyForSign);
        }
      }

      const placeholders = localStorage.getItem("placeholders");
      const placeholdersArr = JSON.parse(placeholders);
      const item = placeholdersArr.find((obj) => obj.object_id === objId);

      let backgroundColor = item.color_code;
      let topPositionObject = item.position.top;
      let leftPositionObject = item.position.left;
      let widthObject = item.position.width;
      let heightObject = item.position.height;
      let requestRecipient = item.recipients;
      let dateFormat = item.date_format;

      let foundRecipient = "";
      if (isFillMode === false) {
        let current_recipient_id = formObj.recipient_detail.id;
        foundRecipient = requestRecipient.find(
          (obj) => obj.recipient_id === current_recipient_id
        );
      } else {
        foundRecipient = item.value_of_recipient;
      }

      let textContent = foundRecipient.value;
      let fontSize = foundRecipient.font_size;
      let fontFamily = foundRecipient.font_family;

      fabricTool(
        backgroundColor,
        topPositionObject,
        leftPositionObject,
        widthObject,
        heightObject,
        objId,
        requestRecipient,
        fontSize,
        fontFamily,
        dateFormat,
        textContent
      );
      setShowSignModal(false);
    }
  };

  const applySign = () => {
    var activeObject = canvas.getActiveObject();
    if (activeObject == null) {
      toast.error("Please select the specific placeholder.");
      return false;
    }

    var objectId = activeObject.id;
    if (activeTab === "type") {
      if (signText === "") {
        toast.error("Please enter the text.");
      } else if (signFont === "") {
        toast.error("Please choose any one text.");
      } else {
        typeTextChange(objectId);
      }
    } else if (activeTab === "draw") {

      if (!hasDrawingObject()) {
        toast.error("Please draw the signature.");
      } else {
        typeDrawChange(objectId);
      }
    } else {
      if (uploadImageBase64 === "") {
        toast.error("Please upload the signature image.");
      } else {
        typeDrawChange(objectId, uploadImageBase64);
      }
    }

    getRequestFieldLeft();
  };

  const typeDrawChange = (objId, signImg = "", isFillMode = false) => {
    var placeholdersUpdated = localStorage.getItem("placeholders");
    var placeholdersArr = JSON.parse(placeholdersUpdated);

    var foundObject = placeholdersArr.find((obj) => obj.object_id === objId);

    const signBase64 = signImg === "" ? convertToBase64() : signImg;
    let objectPosition = foundObject.position;

    canvas.forEachObject(function (obj) {

      if (obj.id === objId) {
        canvas.remove(obj);
      }
    });
    canvas.renderAll();

    var fillColor = "#" + foundObject.color_code;
    var object = new fabric.Rect({
      fill: "#ffffff",
      width: objectPosition.width,
      height: objectPosition.height,
      radius: 1,
      objectCaching: false,
      stroke: fillColor,
      strokeWidth: 3,
      hasControls: false,
      clipTo: function (ctx) {
        ctx.rect(this.left, this.top, this.width, this.height);
      },
    });

    var topPositionObject = objectPosition.top;
    var leftPositionObject = objectPosition.left;

    fabric.Image.fromURL(signBase64, function (img) {
      img.set({
        left: 0,
        top: 0,
        scaleX: objectPosition.width / img.width,
        scaleY: objectPosition.height / img.height,
      });

      let group = new fabric.Group([object, img], {
        id: objId,
        left: leftPositionObject,
        top: topPositionObject,
        lockRotation: true,
        preserveObjectStacking: true,
        lockMovementX: true,
        lockMovementY: true,
        lockScalingX: true,
        lockScalingY: true,
      });

      group.setControlsVisibility({ mtr: false });
      group.set({
        width: objectPosition.width,
        height: objectPosition.height,
      });

      if (isFillMode === true) {
        group.set("selectable", false);
      }

      canvas.add(group);
      group.on('mousedown', mouseDblClickListener);

      if (isFillMode === false) {
        canvas.setActiveObject(group);
      }

      canvas.renderAll();
    });

    if (isFillMode === false) {

      var signInitialData = {
        type: "image",
        font: "",
        value: signBase64
      };

      if (objId.indexOf("sign") > -1) {

        localStorage.setItem("localSign", JSON.stringify(signInitialData));
      }

      if (objId.indexOf("initial-textbox") > -1) {

        localStorage.setItem("localInitial", JSON.stringify(signInitialData));
      }

      if (activeTab === "draw" || activeTab === "upload") {
        storeSignValue(objId, activeTab, signBase64);
      } else {
        storeSignValue(objId, "upload", signBase64);
      }
      setShowSignModal(false);
    }
  };

  const hasDrawingObject = () => {
    if (canvasSignRef.current) {
      const signCanvas = canvasSignRef.current;

      const objects = signCanvas.getObjects();
      for (let i = 0; i < objects.length; i++) {

        if (
          objects[i].type === "path" ||
          objects[i].type === "line" ||
          objects[i].type === "circle"
        ) {

          return true;
        }
      }
    }

    return false;
  };

  function getPlaceholderValue(objId, fontFamily, fontSize, dateFormat) {
    var placeholdersUpdated = localStorage.getItem("placeholders");
    var placeholdersArr = JSON.parse(placeholdersUpdated);

    const foundObject = placeholdersArr.find((obj) => obj.object_id === objId);
    if (foundObject) {
      const foundObjectIndex = placeholdersArr.findIndex(
        (obj) => obj.object_id === objId
      );

      let recipients = foundObject.recipients;
      let current_recipient_id = formObj.recipient_detail.id;
      let current_recipient_name = getCurrentRecipientName();
      let short_name = getInitial(current_recipient_name);
      setSignText(short_name);

      let current_recipient_email = formObj.recipient_detail.email;
      let static_text = foundObject.text_content;
      let current_date = Utils.getCurrentDateByFormat(dateFormat);

      if (signDocMode === 1) {
        let foundRecipient = recipients.find(
          (obj) => obj.recipient_id === current_recipient_id
        );

        if (foundRecipient) {
          let foundRecipientIndex = recipients.findIndex(
            (obj) => obj.recipient_id === current_recipient_id
          );

          recipients[foundRecipientIndex].font_family = fontFamily;
          recipients[foundRecipientIndex].font_size = fontSize;

          if (objId.indexOf("recipient-textbox") > -1) {
            recipients[foundRecipientIndex].type = "text";
            recipients[foundRecipientIndex].value = current_recipient_name;
            let short_name = getInitial(current_recipient_name);
            setSignText(short_name);
          } else if (objId.indexOf("system-date-textbox") > -1) {
            recipients[foundRecipientIndex].type = "text";
            recipients[foundRecipientIndex].value = current_date;
          } else if (objId.indexOf("email-address-textbox") > -1) {
            recipients[foundRecipientIndex].type = "text";
            recipients[foundRecipientIndex].value = current_recipient_email;
          } else if (objId.indexOf("static-textbox") > -1) {
            recipients[foundRecipientIndex].type = "text";
            recipients[foundRecipientIndex].value = static_text;
          }

          placeholdersArr[foundObjectIndex].recipients = recipients;
          localStorage.setItem("placeholders", JSON.stringify(placeholdersArr));

          return recipients[foundRecipientIndex].value;
        }
      } else {
        let request_recipient_id = foundObject.request_recipient.value;
        let foundRecipient = recipients.find(
          (obj) => obj.recipient_id === request_recipient_id
        );

        if (foundRecipient) {
          let foundRecipientIndex = recipients.findIndex(
            (obj) => obj.recipient_id === request_recipient_id
          );

          if (request_recipient_id === current_recipient_id) {
            recipients[foundRecipientIndex].font_family = fontFamily;
            recipients[foundRecipientIndex].font_size = fontSize;

            if (objId.indexOf("recipient-textbox") > -1) {
              recipients[foundRecipientIndex].type = "text";
              recipients[foundRecipientIndex].value = current_recipient_name;
              let short_name = getInitial(current_recipient_name);
              setSignText(short_name);
            } else if (objId.indexOf("system-date-textbox") > -1) {
              recipients[foundRecipientIndex].type = "text";
              recipients[foundRecipientIndex].value = current_date;
            } else if (objId.indexOf("email-address-textbox") > -1) {
              recipients[foundRecipientIndex].type = "text";
              recipients[foundRecipientIndex].value = current_recipient_email;
            }

            placeholdersArr[foundObjectIndex].recipients = recipients;
            localStorage.setItem(
              "placeholders",
              JSON.stringify(placeholdersArr)
            );

            return recipients[foundRecipientIndex].value;
          } else {

            if (recipients[foundRecipientIndex].value === "") {
              if (objId.indexOf("recipient-textbox") > -1) {
                return (
                  "Recipient Name (" +
                  getInitial(foundObject.request_recipient.label) +
                  ")"
                );
              } else if (objId.indexOf("system-date-textbox") > -1) {
                return (
                  "Date Signed (" +
                  getInitial(foundObject.request_recipient.label) +
                  ")"
                );
              } else if (objId.indexOf("email-address-textbox") > -1) {
                return (
                  "Email Address (" +
                  getInitial(foundObject.request_recipient.label) +
                  ")"
                );
              } else {
                return foundObject.text_content;
              }
            } else {
              return recipients[foundRecipientIndex].value;
            }
          }
        }
      }
    }
  }

  function mouseDblClickListener(ev) {
    let target = ev.target;
    let objId = target.id;

    var placeholdersUpdated = localStorage.getItem("placeholders");
    var placeholdersArr = JSON.parse(placeholdersUpdated);

    const foundObject = placeholdersArr.find(
      (obj) => obj.object_id === objId
    );

    if (foundObject) {
      let recipients = foundObject.recipients;
      let current_recipient_id = formObj.recipient_detail.id;

      if (signDocMode === 2) {
        if (current_recipient_id !== foundObject.request_recipient.value) {
          return false;
        }
      }

      if ((objId.indexOf("initial-textbox") > -1) || (objId.indexOf("sign") > -1)) {
        canvas.forEachObject(function (obj) {

          if (obj.id === objId) {

            canvas.setActiveObject(obj);
          }
        });
        canvas.renderAll();
      }

      let foundRecipient = recipients.find(
        (obj) => obj.recipient_id === current_recipient_id
      );

      if (foundRecipient?.value !== "") {
        openSignPadModal(objId)
      } else {

        if (objId.indexOf("sign") > -1) {
          let localSign = localStorage.getItem("localSign");
          if (localSign !== null) {
            localSign = JSON.parse(localSign);
            if (localSign.type === "image") {
              typeDrawChange(objId, localSign.value);
            } else {
              typeTextChange(objId);
            }
          } else {
            openSignPadModal(objId)
          }
        }

        if (objId.indexOf("initial-textbox") > -1) {
          let localInitial = localStorage.getItem("localInitial");
          if (localInitial !== null) {
            localInitial = JSON.parse(localInitial);

            if (localInitial.type === "image") {
              typeDrawChange(objId, localInitial.value);
            } else {
              typeTextChange(objId);
            }

          } else {
            openSignPadModal(objId)
          }
        }

      }
    }

    getRequestFieldLeft();

    return true;
  }

  function openSignPadModal(objId) {
    if (objId.indexOf("sign") > -1 || objId.indexOf("initial") > -1) {

      setSignFont(0);
      let current_recipient_name = getCurrentRecipientName();
      if (objId.indexOf("sign") > -1) {
        setSignText(current_recipient_name);
        selectSignFont(0);
        setActiveTab('type');
        setTitleOfSignInitialPopup("Add Your Signature")
      } else {
        let short_name = getInitial(current_recipient_name);
        setSignText(short_name);
        selectSignFont(0);
        setActiveTab('type');
        setTitleOfSignInitialPopup("Add Your Initial")
      }

      if (signDocMode === 1) {
        setShowSignModal(true);
      } else {
        var placeholdersUpdated = localStorage.getItem("placeholders");
        var placeholdersArr = JSON.parse(placeholdersUpdated);
        const foundObject = placeholdersArr.find(
          (obj) => obj.object_id === objId
        );
        if (foundObject) {
          var currentRecipient = formObj.recipient_detail.id;
          var requestRecipientValue = foundObject.request_recipient.value;
          if (currentRecipient === requestRecipientValue) {
            setShowSignModal(true);
          }
        }
      }
    }
  }

  const changeName = (newValue) => {
    setSignText(newValue);
  };

  const selectSignFont = (index) => {
    setSignFont(index);
  };

  const handleUploadImage = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = () => {

      setUploadImageBase64(reader.result);
    };

    reader.readAsDataURL(file);
  };

  const scrollToPage = (pageNumber) => {
    const scrollableDiv = containerRef.current;

    var pdfHeight = pdfDimensions.height;

    var dynamicHeight = (pageNumber * pdfHeight);

    canvas.setDimensions({ height: dynamicHeight });
    canvas.renderAll();

    const heightPerPage = dynamicHeight / imageList.length;

    scrollableDiv.scrollTop = (pageNumber - 1) * heightPerPage;
  };



  // useEffect(() => {
  //   if (!agreeTermsOfService) {
  //     // setGetStarted(false);
  //     setAgreeTermsOfService(false);
  //     setSignText('');
  //     setSignFont('');
  //     setUploadImageBase64('');
  //     containerRef.current.style.pointerEvents = "none";
  //   }
  // }, [agreeTermsOfService]);

  const handleNextSignRequest = () => {

    let nextObjects = localStorage.getItem("nextObjects");
    let nextObjectsArr = JSON.parse(nextObjects);

    if (nextObjectsArr !== null) {
      let totalLength = (nextObjectsArr.length - 1);
      let findCurrentObjectIndex = nextObjectsArr.findIndex((item) => (item.current === true));

      nextObjectsArr[findCurrentObjectIndex]['current'] = false;

      if (parseInt(totalLength) === parseInt(findCurrentObjectIndex)) {
        findCurrentObjectIndex = 0;
      } else {
        findCurrentObjectIndex += 1
      }

      nextObjectsArr[findCurrentObjectIndex]['current'] = true;

      localStorage.setItem("nextObjects", JSON.stringify(nextObjectsArr));

      activeObjectWithOpenModal(nextObjectsArr[findCurrentObjectIndex].object_id, nextObjectsArr[findCurrentObjectIndex].page);

    } else {
      let placeholdersUpdated = localStorage.getItem("placeholders");
      let placeholdersArr = JSON.parse(placeholdersUpdated);

      if (placeholdersArr !== null) {

        let signRegex = new RegExp("sign", 'i');
        let initialRegex = new RegExp("initial", 'i');

        placeholdersArr = placeholdersArr.filter(function (obj) {

          return (signRegex.test(obj.object_id) || initialRegex.test(obj.object_id));
        })

        let current_recipient_id = formObj.recipient_detail.id;
        let prepareArrayOfNext = [];
        for (let j = 0; j < placeholdersArr.length; j++) {
          let objPlaceholder = placeholdersArr[j];

          let objId = objPlaceholder.object_id;
          let recipients = objPlaceholder.recipients;
          let pageNumber = objPlaceholder.page_object_id;
          pageNumber = pageNumber.match(/\d+/)[0];

          let foundRecipient = "";
          if (signDocMode === 1) {
            foundRecipient = recipients.find(
              (obj) => obj.recipient_id === current_recipient_id
            );
          } else {
            let request_recipient_id = objPlaceholder.request_recipient.value;
            foundRecipient = (request_recipient_id === current_recipient_id) ? true : false;
          }

          if (foundRecipient) {
            prepareArrayOfNext.push({ "page": pageNumber, "object_id": objId, "current": false });
          }
        }

        prepareArrayOfNext[0].current = true;

        localStorage.setItem("nextObjects", JSON.stringify(prepareArrayOfNext));

        activeObjectWithOpenModal(prepareArrayOfNext[0].object_id, 1);
      }
    }
  };

  const activeObjectWithOpenModal = (objId, page) => {
    let currentObject = null;
    canvas.forEachObject(function (obj) {

      if (obj.id === objId) {
        currentObject = obj;

        canvas.setActiveObject(obj);
      }
    });
    canvas.renderAll();

    if (currentObject) {

      scrollToPage(page);

      const scrollableDiv = containerRef.current;
      if (scrollableDiv) {
        scrollableDiv.scrollTop = parseInt(currentObject.top) - 150;
      }

      if (objId.indexOf("sign") > -1) {
        if (localStorage.getItem("localSign") === null) {
          openSignPadModal(currentObject.id);
        }
      }

      if (objId.indexOf("initial-textbox") > -1) {
        if (localStorage.getItem("localInitial") === null) {
          openSignPadModal(currentObject.id);
        }
      }

    } else {
      console.log("Object with ID", objId, "not found");
    }
  }

  const deletePreviewImage = () => {
    inputFileImageRef.current.value = "";
    setUploadImageBase64("");
  };

  const handleScrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft -= 100;
    }
  };

  const handleScrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollLeft += 100;
    }
  };

  const renderSummaryButton = () => {
    if (signatureDocumentData && formObj?.sign_documents) {
      const activeDoc = formObj.sign_documents.find(
        (doc) => doc.id === signatureDocumentData.id
      );
      return (
        <button
          key={activeDoc.id}
          onClick={handleShowSummaryModal}
          className="sign-summary-btn"
        >
          <i className="bi bi-file-text-fill me-2" />
          Summary
        </button>
      );
      // }
    }
    return null;
  };

  useEffect(() => {
    const offcanvasEl = document.getElementById("signFillableForm");
    if (!offcanvasEl) return;

    const handleHidden = () => {
      // 1️⃣ Scroll unlock karne ke liye
      document.body.classList.remove("offcanvas-backdrop", "overflow-hidden");
      document.body.style.overflow = "auto";

      // 2️⃣ Fabric canvas dispose karne ke liye (memory clean)
      if (canvas) {
        try {
          canvas.dispose();
          setCanvas(null);
        } catch (err) {
          console.warn("Canvas dispose issue:", err);
        }
      }

      // 3️⃣ Local states clean (optional but safe)
      setImageList([]);
      setSignDocId(0);
      setSignDocMode(1);
    };

    offcanvasEl.addEventListener("hidden.bs.offcanvas", handleHidden);

    return () => {
      offcanvasEl.removeEventListener("hidden.bs.offcanvas", handleHidden);
    };
  }, [canvas]);


  return (
    <div>
      <div
        className="offcanvas offcanvas-end signFillableForm makeFillableForm"
        data-bs-scroll="true"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        id="signFillableForm"
        aria-labelledby="signFillableFormLabel"
      >
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="signFillableFormLabel">
            Review & Sign
          </h5>

          <button
            type="button"
            ref={clsFormButtonRef}
            className="btn close_btn text-reset"
            data-bs-dismiss="offcanvas"
            onClick={clearForm}
            aria-label="Close"
          >
            <i className="bi bi-x-circle" aria-hidden="true" />
          </button>
        </div>

        <div className="request-field-left">
          <span>Request field left : </span>{" "}
          <span className="text-danger">{requestFieldLeft}</span>
        </div>

        <div
          className="d-none"
          onClick={handleAutoFillEditMode}
          ref={autoFillEditModeRef}
        ></div>
        <div
          className="offcanvas-body p-0 "
          ref={offCanvasBodyRef}
          style={{ overflowX: "hidden", overflowY: "hidden" }}
        >
          <div className="">
            <div className="row">
              {/* <div className="col-1 tools-wrapper"></div> */}

              <div className="col-12">
                <div className="view-wrapper">
                  <div
                    className="card rounded dt-bg-silver m-card-scroll handle"
                    ref={containerRef}
                  >

                    <div
                      className="page-wrapper"
                      style={{ position: "relative", display: "flex", justifyContent: "center", left: (window.innerWidth < 500) ? "0px" : "" }}
                    >
                      <canvas id="canv" style={{ border: "none" }} />
                    </div>


                  </div>
                </div>
                {/* {(window.innerWidth < 500 && agreeTermsOfService) &&
                  <div className="text-center mt-4 canvas-ho-scroll">
                    <button onClick={handleScrollLeft} className="m-1"><i className="fa fa-arrow-circle-o-left" aria-hidden="true"></i></button>
                    <button onClick={handleScrollRight} className="m-1"><i className="fa fa-arrow-circle-o-right" aria-hidden="true"></i></button>
                  </div>
                } */}
              </div>
              {/* <div className="col-1 tools-wrapper"></div> */}

            </div>
          </div>

          {/* Modern Footer with Actions */}
          <div className="modal-footer">
            {renderSummaryButton()}
            {requestFieldLeft === 0 ? (
              <button
                type="button"
                onClick={saveForm}
                className="sign-btn-complete"
              >
                Complete Signing
              </button>
            ) : (
              <button
                type="button"
                onClick={handleNextSignRequest}
                className="sign-btn-next"
              >
                Next
              </button>
            )}
          </div>

          <ModalComponent
            show={showSummaryModal}
            handleClose={handleCloseSummaryModal}
            title="Document Summary"
            size="lg"
            footerButtons={[
              {
                label: "Close",
                variant: "secondary",
                onClick: handleCloseSummaryModal,
              },
            ]}
          >
            <CustomerSummary
              show={showSummaryModal}
              onClose={handleCloseSummaryModal}
              summaries={summaries}
              setSummaries={setSummaries}
              loading={false}
            />
          </ModalComponent>

          <div
            className={`modal fade ${showSignModal ? "show" : ""}`}
            id="signModal"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="signModalLabel"
            aria-hidden={!showSignModal}
          >
            <div className="modal-dialog modal-dialog-centered" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="signModalLabel">
                    {titleOfSignInitialPopup}
                  </h5>
                  <button type="button" className="signature-modal-close" onClick={() => setShowSignModal(false)}>
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                  </button>
                </div>

                <div className="modal-body">
                  <div className="sign-tab-container">
                    {/* Tab Navigation */}
                    <div className="d-flex sign-tab-container-bg">
                      <div className="flex-fill">
                        <button
                          onClick={() => handleTabClick("type")}
                          className={`sign-tab-button ${activeTab === "type" ? "active" : ""}`}
                        >
                          Font
                        </button>
                      </div>
                      <div className="flex-fill">
                        <button
                          onClick={() => handleTabClick("draw")}
                          className={`sign-tab-button ${activeTab === "draw" ? "active" : ""}`}
                        >
                          Draw
                        </button>
                      </div>
                      <div className="flex-fill">
                        <button
                          onClick={() => handleTabClick("upload")}
                          className={`sign-tab-button ${activeTab === "upload" ? "active" : ""}`}
                        >
                          Upload
                        </button>
                      </div>
                    </div>

                    {/* Tab Content */}
                    <div className="tab-content">
                      {/* Type Tab */}
                      <div className={activeTab === "type" ? "sign-type-box" : "sign-type-box d-none"}>
                        <div className="d-flex justify-content-between sign-section-header">
                          <span className="sign-section-title">Select Style
                            <i className="bi bi-info-circle ms-2 cur-pointer sign-info-icon" data-tooltip="tooltip" data-bs-placement="top" title="This document can be signed electronically. Please type your
                            signature in the box and select a font then click sign. You can also draw or upload your signature as alternative ways to sign."/>
                          </span>
                        </div>

                        <div className="sign-name-wrapper d-flex align-items-center my-3">
                          <div className="sign-name-label">
                            <span>Your Name</span>
                          </div>
                          <div className="flex-fill">
                            <input
                              ref={yourNameRef}
                              type="text"
                              placeholder="Your Name"
                              value={signText}
                              onInput={(e) => changeName(e.target.value)}
                              className="sign-name-input"
                            />
                          </div>
                        </div>

                        <div className="row g-3">
                          {[...Array(6)].map((_, index) => (
                            <div key={index} className="col-6">
                              <div onClick={() => selectSignFont(index)}>
                                <div className={`sign-font-box ${index === signFont ? "active" : ""}`}>
                                  <span className={`sign-font-type-${index} sign-font-text`}>
                                    {signText === "" ? "John Doe" : signText}
                                  </span>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="mt-3 sign-note-box" >
                          <span className="sign-note-text">
                            This document can be signed electronically. Please type your
                            signature in the box and select a font then click sign. You
                            can also draw or upload your signature as alternative ways to
                            sign.
                          </span>
                        </div>
                      </div>

                      {/* Draw Tab */}
                      <div className={activeTab === "draw" ? "sign-draw-box" : "sign-draw-box d-none"}>
                        <div className="signpad-container">
                          <div className="d-flex justify-content-between sign-section-header">
                            <span className="sign-section-title">Draw Your Signature
                              <i className="bi bi-info-circle ms-2 cur-pointer sign-info-icon" data-tooltip="tooltip" data-bs-placement="top" title="This document can be signed electronically. Please draw your signature in the box and click sign. You can also type or upload your signature as alternative ways to sign." />
                            </span>
                            <span onClick={() => clearSignPad()} className="sign-clear-link">
                              Clear
                            </span>
                          </div>

                          <div className="sign-canvas-wrapper">
                            <canvas
                              ref={canvasSignRef}
                              id="signatureCanvas"
                              className="sign-canvas"
                              width={
                                window.innerWidth < 500
                                  ? (window.innerWidth * 80) / 100
                                  : 450
                              }
                              height={
                                window.innerWidth < 500
                                  ? (window.innerWidth * 50) / 100
                                  : 190
                              }
                            ></canvas>
                          </div>
                        </div>

                        <div className="mt-3 sign-note-box">
                          <span className="sign-note-text">
                            This document can be signed electronically. Please draw your
                            signature in the box and click sign. You can also type or
                            upload your signature as alternative ways to sign.
                          </span>
                        </div>
                      </div>

                      {/* Upload Tab */}
                      <div className={activeTab === "upload" ? "sign-upload-box" : "sign-upload-box d-none"}>
                        <div className="d-flex justify-content-between sign-section-header">
                          <span className="sign-section-title">Preview
                            <i className="bi bi-info-circle ms-2 cur-pointer sign-info-icon" data-tooltip="tooltip" data-bs-placement="top" title="This document can be signed electronically. Please upload your signature and click sign. You can also draw or type your signature as alternative ways to sign. (Note: the ideal size of the image is 400x145px as the uploaded image will be resized to these dimensions)" />
                          </span>
                          <span onClick={() => deletePreviewImage()} className="sign-delete-link">
                            Delete
                          </span>
                        </div>

                        <div className="sign-upload-wrapper my-3">
                          <div className="sign-upload-area">
                            <label htmlFor="document_file" className="sign-upload-label">
                              <div className="sign-upload-icon">
                                <i className="bi bi-cloud-arrow-up" aria-hidden="true"></i>
                              </div>
                              <h5 className="sign-upload-text">
                                Drag &amp; Drop to Upload File here or click to upload
                              </h5>
                            </label>
                            <input
                              ref={inputFileImageRef}
                              onChange={handleUploadImage}
                              type="file"
                              id="document_file"
                              name="image"
                              accept="image/png, image/jpeg"
                              className="sign-upload-hidden"
                            />
                          </div>

                          {uploadImageBase64 && (
                            <div className="sign-preview-container">
                              <h2 className="sign-preview-title">Uploaded Image:</h2>
                              <img
                                src={uploadImageBase64}
                                alt="Uploaded"
                                className="sign-preview-image"
                              />
                            </div>
                          )}
                        </div>

                        <div className="mt-3 sign-note-box">
                          <span className="sign-note-text">
                            This document can be signed electronically. Please upload your
                            signature and click sign. You can also draw or type your
                            signature as alternative ways to sign. (Note: the ideal size
                            of the image is 400x145px as the uploaded image will be
                            resized to these dimensions)
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Modal Footer */}
                <div className="sign-modal-footer">
                  <button
                    type="button"
                    onClick={() => clearSignValue()}
                    className="btn sign-btn-close"
                    data-dismiss="modal"
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    onClick={() => applySign()}
                    className="btn sign-btn-submit"
                  >
                    Sign
                  </button>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>


  );

}

export default SignFillablePopup;